<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>vừa</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> về </span>
    <span class="event">"{{ taskTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      taskTitle: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DK_PHONGHOP:
          action = "Đăng ký phòng họp";
          this.taskTitle = this.dataJson.hcCasePhonghop.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.HUY_PHONG_HOP:
          action = "Hủy phòng họp";
          this.taskTitle = this.dataJson.hcCasePhonghop.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .CAP_NHAT_PHONG_HOP:
          action = "Cập nhật phòng họp";
          this.taskTitle = this.dataJson.hcCasePhonghop.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .PHE_DUYET_PHONG_HOP:
          action = "Phê duyệt phòng họp";
          this.taskTitle = this.dataJson.hcCasePhonghop.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH
          .TU_CHOI_PHONG_HOP:
          action = "Từ chối phòng họp";
          this.taskTitle = this.dataJson.hcCasePhonghop.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.DANG_KY:
          action = "Đăng ký điều xe";
          this.taskTitle = this.dataJson.hcCaseDieuXe.title;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.TU_CHOI:
          action = "Từ chối điều xe";
          this.taskTitle = this.dataJson.hcCaseDieuXe.title;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .PHE_DUYET:
          action = "Phê duyệt điều xe";
          this.taskTitle = this.dataJson.hcCaseDieuXe.title;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE
          .HUY_YEU_CAU:
          action = "Hủy điều xe";
          this.taskTitle = this.dataJson.hcCaseDieuXe.title;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.DIEU_XE.CAP_NHAT:
          action = "Cập nhật điều xe";
          this.taskTitle = this.dataJson.hcCaseDieuXe.title;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .DANG_KY:
          action = "Đăng ký lịch tuần";
          this.taskTitle = this.dataJson.hcCaseCalendar.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .TU_CHOI:
          action = "Từ chối lịch tuần";
          this.taskTitle = this.dataJson.hcCaseCalendar.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .PHE_DUYET:
          action = "Phê duyệt lịch tuần";
          this.taskTitle = this.dataJson.hcCaseCalendar.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .HUY_YEU_CAU:
          action = "Hủy lịch tuần";
          this.taskTitle = this.dataJson.hcCaseCalendar.meetingTitle;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.HANH_CHINH.LICH_TUAN
          .CAP_NHAT:
          action = "Cập nhật lịch tuần";
          this.taskTitle = this.dataJson.hcCaseCalendar.meetingTitle;
          break;
        default:
          break;
      }
      this.fromActorFullName = this.vbNotificationView.fromUserName;
      this.action = action;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-hanhchinh.vue